import { render, staticRenderFns } from "./lawyer.vue?vue&type=template&id=6b011e6d&scoped=true&"
import script from "./lawyer.vue?vue&type=script&lang=js&"
export * from "./lawyer.vue?vue&type=script&lang=js&"
import style0 from "./lawyer.vue?vue&type=style&index=0&id=6b011e6d&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b011e6d",
  null
  
)

export default component.exports